<template>
	<video
      id="video"
      class="video"
      :src="mediaurl"
      controls = "true"
      :poster="imgurl"
      preload="auto"
      webkit-playsinline="true"
      playsinline="true"
      x-webkit-airplay="allow"
      x5-video-player-type="h5"
      x5-video-player-fullscreen="true"
    >
    </video>
</template>
<script>
    import './index.less'
    export default {
        name:"video",
        data() {
            return {
                mediaurl: '',
                imgurl:''
            }
        },
        components: {
        },
        methods: {
        },
        mounted(){
        	this.mediaurl = this.$route.params.mediaurl;
        	this.imgurl = this.$route.params.imgurl;
        }
    }
</script>
